
export const menus = [
  {
    title: 'Admin',
    items: [
      {
        title: 'Home',
        path: '/',
        // icon: <Use />
      },
      {
        title: 'Teste',
        path: '/connections',
        // icon: <Users />,
      },
    ]
  },
];
